/**
 * Tag utilities for parsing user tags
 */

export interface UserProfileTags {
  gender?: string;
  birthYear?: number;
  locations: string[];
}

/**
 * Parse user tags array into structured profile data
 */
export function parseUserTags(tags: string[] | null | undefined): UserProfileTags {
  const result: UserProfileTags = {
    locations: [],
  };

  if (!tags) return result;

  for (const tag of tags) {
    if (tag.startsWith('@gender=')) {
      result.gender = tag.substring('@gender='.length);
    } else if (tag.startsWith('@birth-year=')) {
      const year = parseInt(tag.substring('@birth-year='.length), 10);
      if (!isNaN(year)) {
        result.birthYear = year;
      }
    } else if (tag.startsWith('@location=')) {
      result.locations.push(tag.substring('@location='.length));
    }
  }

  return result;
}
